import { render } from "./intro-video-button.vue?vue&type=template&id=e25823a8"
import script from "./intro-video-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./intro-video-button.vue?vue&type=script&setup=true&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "e25823a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e25823a8', script)) {
    api.reload('e25823a8', script)
  }
  
  module.hot.accept("./intro-video-button.vue?vue&type=template&id=e25823a8", () => {
    api.rerender('e25823a8', render)
  })

}

script.__file = "resources/ts/components/elements/intro-video-button.vue"

export default script